import Api from "./Api";
export default {
  storePaginate(paginate) {
    return Api().post("/promotion/storepage", paginate);
  },

  save(id, form) {
    return Api().patch("/promotion/" + id, form);
  },

  create(form) {
    return Api().post("/promotion", form);
  },
};
